<template>
  <div class="w-full">
    <vs-alert title="Catatan" class="my-5">
      Berikut ini merupakan laporan presensi per bulan berdasarkan petugas MPP yang dipilih.
    </vs-alert>
    
    <div class="vx-col w-full">
      <vx-card class="my-5">
        <div class="w-full flex flex-col md:flex-row">
          <div class="w-full flex">
            <div class="w-full md:w-1/4 px-3 mb-1">
              <div class="mb-2">Pilih Petugas MPP</div>
              <v-select :options="listUser" v-model="selectedUser" />
            </div>
            <div class="w-full md:w-1/4 px-3 mb-1">
              <div class="mb-2">Pilih Bulan</div>
              <v-select :options="listMonth" v-model="selectedMonth" />
            </div>
            <div class="w-full md:w-1/4 px-3 mb-1">
              <div class="mb-2">Pilih Tahun</div>
              <v-select :options="listYear" v-model="selectedYear" />
            </div>
            <div class="w-full md:w-1/4 px-3 mb-1">
              <div class="mb-2">.</div>
              <vs-button
                class="justify-center"
                type="border"
                size="medium"
                icon-pack="feather"
                icon="icon-download"
                :disabled="disableDownload"
                @click="downloadReport()"
                >Download Laporan
              </vs-button>
            </div>
          </div>
          <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {SELECT_OPTION_YEAR_LIST, SELECT_OPTION_MONTH_LIST } from "@/const/attendance";

export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    SELECT_OPTION_YEAR_LIST,
    SELECT_OPTION_MONTH_LIST
  },
  data() {
    return {
      date: '',
      datepickerConfig: {
        disabledDates : {
          days : [6,0],
          dates: [],
        },
      },
      selectedUser: {id: '', label: 'Pilih Petugas'},
      selectedMonth: {id: '', label: 'Pilih Bulan'},
      selectedYear: {id: '', label: 'Pilih Tahun'},
      listUser: [],
      listYear: SELECT_OPTION_YEAR_LIST,
      listMonth: SELECT_OPTION_MONTH_LIST
    }
  },
  computed:{
    disableDownload(){
      return this.selectedUser.id === '' ||
        this.selectedMonth.id === '' ||
        this.selectedYear.id === '';
    }
  },
  mounted(){
    this.getUsers();
  },
  methods:{
    downloadReport(){
      let data = {
        month: this.selectedMonth.id,
        year: this.selectedYear.id,
        user_id: this.selectedUser.id, 
        type: 'by_user_report'
      };

      this.$http.get("/app/secure/attendance-info/download-report",  {params: data})
      .then(response => {
        let url = response.data.data.report;
        window.setTimeout(function(){ 
          window.open(url);
        },500);
      })
      .catch(e => {
        this.parseError(e);
      });
    },
    getUsers(){
      this.$http.get("/app/secure/attendance-info/users")
      .then(response => {
        this.listUser = response.data.data.users;
      })
      .catch(e => {
        this.parseError(e);
      });
    }
  }
};
</script>